/** The Express sidebar group: ข้อมูล Express and ใบลดหนี้/ใบเพิ่มหนี้ hang from it. */
export const EXPRESS_PATH = "/express";

export const EXPRESS_DATA_PATH = `${EXPRESS_PATH}/data`;

/** Where ข้อมูล Express lived under รายงาน; kept as a redirect so saved links still land. */
export const LEGACY_EXPRESS_DATA_PATH = "/report/express-data";
